import * as React from 'react';

function SvgMoneyOutline(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
      <path d="M3 21h26v2H3zM3 25h26v2H3zM3 5v14h26V5zm24 12H5V7h22z" />
      <path d="M16 16a4 4 0 10-4-4 4 4 0 004 4zm0-6a2 2 0 11-2 2 2 2 0 012-2z" />
      <circle cx={9} cy={12} r={1} />
      <circle cx={23} cy={12} r={1} />
    </svg>
  );
}

export default SvgMoneyOutline;
